import React, { useState } from 'react';
import {
    Box,
    Heading,
    VStack,
    FormControl,
    FormLabel,
    Input,
    Textarea,
    Button,
    Text,
    Icon,
    Link,
    HStack,
} from '@chakra-ui/react';
import { useToast } from '@chakra-ui/react'
import { FaEnvelope, FaGithub, FaLinkedin } from 'react-icons/fa';

const Contact = ({ bg, color }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');
    const toast = useToast();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            const response = await fetch('https://formcarry.com/s/_IbEwAZqYyl', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ name, email, message }),
            });

            const responseData = await response.json();
            if (responseData.code === 200) {
                toast({
                    title: 'Message sent successfully!',
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                });
                setError('');
                setName('');
                setEmail('');
                setMessage('');
            } else {
                // Handle Formcarry specific errors (e.g., 422 for validation)
                setError(responseData.message);
            }
        } catch (error) {
            setError(error.message ? error.message : error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Box id="contact" p={5} bg={bg} borderRadius="lg" boxShadow="md">
            <Heading as="h2" size="lg" color={color}>
                Contact
            </Heading>
            <VStack spacing={4}>
                <FormControl isRequired>
                    <FormLabel htmlFor="name">Your Name</FormLabel>
                    <Input id="name" type="text" value={name} onChange={(e) => setName(e.target.value)} />
                </FormControl>
                <FormControl isRequired>
                    <FormLabel htmlFor="email">Your Email</FormLabel>
                    <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                </FormControl>
                <FormControl isRequired>
                    <FormLabel htmlFor="message">Message</FormLabel>
                    <Textarea id="message" value={message} onChange={(e) => setMessage(e.target.value)} />
                </FormControl>
                <Button type="submit" isLoading={isSubmitting} disabled={isSubmitting} onClick={handleSubmit}>
                    Send Message
                </Button>
                {error && <p  style={{color:'red'}}>{error}</p>}
                <VStack spacing={4} textAlign="center">
                    <Text fontSize="lg" fontWeight="semibold" mb={2}>
                        Feel free to reach out for collaborations or just a friendly chat:
                    </Text>
                    <HStack spacing={2} alignItems="center">
                        <Text>Email:</Text>
                        <Link href="mailto:sourav.sharma.engineer@gmail.com" isExternal>
                            sourav.sharma.engineer@gmail.com
                        </Link>
                        <Icon ml={1} as={FaEnvelope} />
                    </HStack>
                    <HStack spacing={2} alignItems="center">
                        <Text>GitHub:</Text>
                        <Link href="https://github.com/suiisharma" isExternal>
                            suiisharma
                            <Icon ml={1} as={FaGithub} />
                        </Link>
                    </HStack>
                    <HStack spacing={2} alignItems="center">
                        <Text>LinkedIn:</Text>
                        <Link href='https://www.linkedin.com/in/sourav-sharma-646291222/' isExternal>
                            Sourav Sharma
                            <Icon ml={1} as={FaLinkedin} />
                        </Link>
                    </HStack>
                    <Text mt={4}>
                        If you have a project, a website need, or a role that aligns with my skills, I'd love to hear from you!
                    </Text>
                </VStack>
            </VStack>
        </Box>
    );
};

export default Contact;
